import React from 'react';
import Contact from '../components/Contact';
import SocialMedia from '../components/SocialMedia';

const ContactPage = () => {
  return (
    <div className="w-full px-4 py-12 md:py-16">
      <div className="max-w-5xl mx-auto">
        <div className="relative mb-12 md:mb-16 text-center overflow-hidden rounded-3xl border border-gold/20 px-6 py-12 md:py-16">
          <div className="pointer-events-none absolute inset-0">
            <div className="absolute inset-0 bg-gradient-to-br from-navy-900 via-navy-800 to-navy-950"></div>
            <div className="absolute top-0 left-1/2 -translate-x-1/2 w-80 h-80 bg-gold/15 rounded-full blur-3xl"></div>
          </div>
          <div className="relative z-10">
            <span className="inline-block text-xs md:text-sm font-bold uppercase tracking-[0.3em] text-gold/80 mb-4">
              Buradayız
            </span>
            <h1 className="text-4xl md:text-6xl font-extrabold text-gold mb-5 drop-shadow-[0_0_25px_rgba(212,175,55,0.6)]">
              İletişim
            </h1>
            <p className="text-base md:text-lg text-white/75 max-w-2xl mx-auto leading-relaxed">
              Sorularınız, önerileriniz veya iş birliği talepleriniz için aşağıdaki kanallardan bize ulaşabilirsiniz.
              Ekibimiz size en kısa sürede dönüş yapacaktır.
            </p>
          </div>
        </div>

        <section className="mb-14">
          <Contact />
        </section>

        <section>
          <SocialMedia />
        </section>
      </div>
    </div>
  );
};

export default ContactPage;
